import React from "react";
import {InventoryItem} from "./interfaces";
import ItemSlot from "./ItemSlot";

interface InventoryGridProps {
    label: string
    slotCount: number
    cols: number
    items: InventoryItem[]
    slotPx?: number
}

export default function InventoryGrid({label, slotCount, cols, items, slotPx = 56}: InventoryGridProps) {
    const bySlot = new Map<number, InventoryItem>()
    items.forEach(it => bySlot.set(it.slot, it))

    return (
        <div className="w-fit mx-auto">
            <h4 className="mb-2 text-sm font-bold uppercase tracking-wide text-neutral-400">{label}</h4>
            <div
                className="grid gap-1"
                style={{gridTemplateColumns: `repeat(${cols}, ${slotPx}px)`}}>
                {Array.from({length: slotCount}, (_, i) => (
                    <ItemSlot key={i} item={bySlot.get(i)}/>
                ))}
            </div>
        </div>
    )
}
